module.exports = __webpack_public_path__ + "3e071b0be67800d6c895ada859f837e4.png";